// extracted by mini-css-extract-plugin
export default {"container":"dropdown-option_container__yftqf","label":"dropdown-option_label__WhpBk","center":"dropdown-option_center__YWpjj","count":"dropdown-option_count__+0CrT"};